export default {
  retrieveClassList (state, payload) {
    state.classList = payload.classList

  },
  addClassToList (state, payload) {
    state.classList.push(payload.student)
  },
  getClassInfo (state, payload) {
    state.classInfo = payload.classInfo
  },
  deleteClass (state, payload) {
    let index = state.classList.findIndex((item) => {
      return item.id === payload.classInfo.class_id
    })

    if (index !== -1) {
      state.classList.splice(index, 1);
    }
  },
  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }
}
